/**
 * The sessionStorage key prefix under which `reportConversionPageVisit`
 * records each Conversion Page it reported, one key per page. Its own module
 * so Withdrawal can clear the keys without loading the senders.
 */
export const CONVERSION_PAGE_REPORTED_PREFIX = 'conversion-page-reported:';

/**
 * Every such key, as a `MarketingTagStorage` pattern. Withdrawal clears them
 * with what the tags store, since each holds an id sent to the Marketing Platforms.
 */
export const CONVERSION_PAGE_REPORTED_STORAGE = `${CONVERSION_PAGE_REPORTED_PREFIX}*`;
